import K8ProgramRoleTileContainer from './container'
export default K8ProgramRoleTileContainer
